import { collection, query, where, getDocs } from 'firebase/firestore'
import { homeDb as db } from '@pulse/firebase/firebaseapi' // global data: always the home database
import { COLLECTIONS } from '../../constants/constants'
export const getMasterPermission = async () => {
  try {
    const permissionsQuery = query(collection(db, COLLECTIONS.MASTER_PERMISSIONS), where('inherit', '==', true), where('type', '==', import.meta.env.VITE_PORTAL))
    const querySnapshot = await getDocs(permissionsQuery)
    const permissions = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
    return permissions
  } catch (error) {
    console.error('Error fetching master permission data:', error)
  }
}
